import { render, staticRenderFns } from "./EpaperBookmarkDialog.vue?vue&type=template&id=ec2f731c&"
import script from "./EpaperBookmarkDialog.vue?vue&type=script&lang=js&"
export * from "./EpaperBookmarkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports